<template>
  <h2 class="mb-4">{{ $store.state.currentPoll ? $store.state.currentPoll.question : '' }}</h2>
</template>

<script>
export default {
  name: 'CurrentPollTitle'
}
</script>
